export default __webpack_public_path__ + "static/media/feature1_4.9c2dd2af.png";